import styled, { keyframes } from 'styled-components';

const spinAnimation = keyframes`
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
`;

const Loader = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 16px solid #f3f3f3;
  border-top: 16px solid blue;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  margin: 25px;
  animation: spin 5s linear infinite;
  animation-name: ${spinAnimation};
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
`;

const ButtonWrapper = styled.button`
  padding: 10px 127px;
  background-color: ${(props) => props.disabled ? "#9da5e7" : "#5e6ff9"};
  color: white;
  border: none;
  cursor: ${(props) => props.disabled ? "not-allowed" : "pointer"};
  font-size: 16px;
  border-radius: 13px;
  margin-top: 1rem;
`;

const ModalBody = styled.div`
  text-align: center;
  p {
    font-size: 16px;
  }
  h2 {
    > div {
      justify-content: center;
    }
  }

  .otp_input input {
    width: 50px !important;
    height: 50px;

    @media (min-width: 768px) {
      width: 70px !important;
    }
  }
`;

export {
  Loader,
  ButtonWrapper,
  ModalBody
}